<template>
    <AppLayoutBase>
        <template slot="drawer">
            <AppLayoutNavbarDrawer title="Mitarbeiter-Gespräche">
                <template slot="img">
                    <img src="@/assets/employee-interview-primary.svg" alt="Mitarbeiter-Gespräche"/>
                </template>
                <template slot="list">
                    <EmployeeInterviewsLayoutDrawer/>
                </template>
            </AppLayoutNavbarDrawer>
        </template>

        <template slot="main">
            <EmployeeInterviewsEmployeesShowContent/>
        </template>
    </AppLayoutBase>
</template>

<script>
    export default {
        name: ""
    }
</script>

<style scoped>

</style>